import get from "lodash/get";
import groupBy from "lodash/groupBy";
import sortBy from "lodash/sortBy";
import moment from "moment";
import {useEffect, useState, useRef} from "react";
import {useNavigate} from "react-router-dom";

import Button from "@mui/material/Button";
import CalendarIcon from '@mui/icons-material/CalendarToday';
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ViewDetalsIcon from '@mui/icons-material/Visibility';

import CustomTextField from "../common/CustomTextField";
import MyMessage from "./MyMessage";
import ResponseBubble from "./ResponseBubble";
import MessageItem from "./MessageItem";
import SchedulePatientButton from "../patients/SchedulePatientButton";
import {formatPatientName} from "../../helpers/patients";
import config from '../../config/config';
import BackButton from "../common/BackButton";
import MarkdownEditor from "../common/MarkdownEditor";
import useIsMobile from "../../hooks/useIsMobile";

// import "./ViewMessageThreadScreen.scss";
const ViewMessageThreadScreen = (props) => {
  const isMobile = useIsMobile();
  const bottomRef = useRef();
  const navigate = useNavigate();
  const {user, otherUserId, messages, onMarkUnread, otherUser, text} = props;
  const [initialMessageText, setInitialMessageText] = useState(text);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const messagesByDate = groupBy(
    sortBy(messages || [], (m) => new Date(m.date_sent)),
    (m) => moment(m.date_sent).format("M/D/yyyy")
  );
  const dateKeys = Object.keys(messagesByDate);
  const message = {
    message: text,
    user_to_id: otherUserId,
  };
  useEffect(() => {
    if (bottomRef) {
      const scrollHeight = bottomRef?.current?.scrollIntoView({
        behavior: "auto",
      });
    }
  }, [bottomRef]);
  const Wrapper = props.noContainer ? Box : Paper;
  console.log('initialMessageText', initialMessageText);
  return (
    <Stack className="ViewMessageThreadScreen" width={'100%'} sx={{
      paddingTop: {xs: '0', sm: '15px'}
    }}>
      {!props.hideBackButton && (
        <Stack direction="row" sx={{
          padding: {xs: '0', sm: '7px 0 0 8px'},
        }}>
          <BackButton variant="backButton"
            className="ViewMessageThreadScreen__back-button"
            sx={{
              flexDirection: 'row',
              textAlign: 'left',
              padding: 0,
              margin: {xs: '5px 0 20px 0', sm: 0}
            }}/>
        </Stack>
      )}
      <Wrapper 
          className={props.noContainer ? "" : "ViewMessageThreadScreen-container"}
          width={'100%'}
          flexDirection={'row'}
          sx={
            props.noContainer ? {} : {
            borderRadius: props?.borderRadius || '12px',
            marginTop: {xs: 0, sm: '32px'},
            // padding: {xs: '5px 9px', sm: '4px 60px 0 60px'}
          }}
      >
        <Stack alignItems={'center'} marginBottom={'10px'}>
          <Typography 
            flexDirection="row"
            padding={'10px 0 10px 0'}
            alignItems="center"
            variant="largeSemiBoldLooseInter"
          >
            {otherUser ? formatPatientName(otherUser) : ""}
          </Typography>
        </Stack>
        <Box className="message-history"
            //  margin={{xs: '10px 0 20px 0', sm: '30px 0 29px 0'}}
             sx={{gap: '17pxx'}}
             style={{
                maxHeight: isMobile ? '60vh' : '70vh',
                overflowY: 'scroll',
             }}
             padding={0}
        >
          {dateKeys && dateKeys.length ? null : (
            <Box className="message-history__empty-message-box" paddingTop={'2em'}>
              <Typography
                variant="h2"
                align="center"
                color={config().colors.muted}
              >
                It looks like you haven't sent any messages yet.
              </Typography>
            </Box>
          )}
          {(dateKeys || []).map((k, i) => (
            <Stack 
              key={k} 
              className="message-history-block"
              // padding={'8px'}
              // paddingRight={{xs: '17px', sm: '0'}}
              pt={i > 0 ? 3 : 0}
              justifyContent='center'
            >
              {i > 0 && <Divider />}
              <Typography 
                className="message-history-block-send-date"
                mt={2}
                color='text.light'
                variant="smallSemiBoldTightInter"
                align='center'
              >
                {moment(get(messagesByDate, `[${k}][0].date_sent`)).format(
                  "ll"
                )}
              </Typography>
              {messagesByDate[k].map((m) =>
                <MessageItem 
                  message={m} 
                  user={user}
                  wasSentByMe={user?.id === m?.user_from.id}
                  onMarkUnread={onMarkUnread} 
                  key={m.id}
                />
                // user?.id === m?.user_from.id ? (
                //   <MyMessage message={m}/>
                // ) : (
                //   <ResponseBubble message={m} onMarkUnread={onMarkUnread}/>
                // )
              )}
              <div ref={bottomRef}/>
            </Stack>
          ))}
        </Box>
        <Stack 
          className="ViewMessageThreadScreen__message-editor" 
          gap={'10px'}
          mt={2}
          style={{borderTop: '1px solid #E0E0E0'}}
        >
          {/* <CustomTextField
            class="ViewMessageThreadScreen__message-editor__text-field"
            type="textarea"
            multiline
            rows={4}
            value={text}
            disabled={props.isSubmitting}
            onChange={props.onChange}
            fullWidth
          /> */}
          <Box p={4} style={{minHeight: '143px'}}>
            <MarkdownEditor
              isLoading={isSubmitting}
              disabled={isSubmitting}
              onChange={props.onChange}
              fullWidth
              defaultValue={initialMessageText}
              footerContent={
                <Stack 
                  direction='row' 
                  justifyContent='space-between' 
                  alignItems='center'
                  width='100%'
                >
                  <Stack direction='row' spacing={0.5}>
                    {!!props.isProvider && 
                      <Button
                        variant='text'
                        size='small'
                        onClick={() => props.onViewPatientProfile()}
                        fullWidth={true}
                        iconOnly={isMobile}
                      >
                        <ViewDetalsIcon style={{marginRight: '0.25em'}}/>
                        View Profile
                      </Button>
                    }
                    {
                      props.isProvider
                      ? <SchedulePatientButton
                        color='primary'
                        variant='text'
                        size='small'
                        patientId={otherUser.id}
                        iconOnly={isMobile}
                      />
                      : <Button
                        color='primary'
                        variant='text'
                        size='small'
                        onClick={() => navigate(`/clients/appointments/new/${otherUser.id}`)}
                      >
                        <CalendarIcon style={{marginRight: '0.25em'}}/>
                        Schedule
                      </Button>
                    }
                  </Stack>
                  <Button
                    variant='contained'
                    size='small'
                    disabled={isSubmitting}
                    sx={{borderRadius: '0px 0px 2px 0px'}}
                    onClick={async () => {
                      setIsSubmitting(true);
                      if (message?.message) setInitialMessageText(message.message)
                      const response = await props.onSendMessage({...message});
                    if (response && !response?.error) {
                        setInitialMessageText('');
                        if (bottomRef.current) {
                          setTimeout(() => {
                            bottomRef?.current?.scrollIntoView({ behavior: "auto" });
                          }, 500);
                        }
                      }
                      setIsSubmitting(false);
                      return response;
                    }}
                  >
                    <SendIcon/>
                    {' '}Send
                  </Button>
                </Stack>
              }
            />
          </Box>
        </Stack>
      </Wrapper>
    </Stack>
  );
};

export default ViewMessageThreadScreen;
